module.exports = __webpack_public_path__ + "img/Arrow2.9b6cbca4.svg";